import { clientIdentification } from '@gjensidige/service-client-identification';

import { Answers } from './types';
import { Step } from './types/enums';

export const mergeClassNames = (first: string, second?: string) => {
  return second ? `${first} ${second}` : first;
};

export const getLatestStepToGoToFromAnswers = (answers: Answers): Step => {
  return Object.entries(answers).findIndex(([, val]) => val === '') as Step;
};

const applicationId = clientIdentification.getApplicationId();
export const CUSTOMER_SEGMENT =
  !applicationId || applicationId === 'INTERNETT' ? 'privat' : 'bedrift';
